/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApiResponse {
  /**
   * 응답 코드 (0=성공, 그 외=오류)
   * @default 0
   */
  code: number;
  /** 응답 데이터 */
  data: Record<string, any>;
  /** 응답 메시지. 응답 코드가 0이 아닌 경우 오류 메시지. */
  message: string;
}

export interface ChatRoomHServiceLastMessageUsers {
  /** 채팅방에 참여중인 서비스 ID */
  hserviceID: HService;
  /** 채팅방에 참여중인(Push notification을 받아야 하는.) 유저의 ID 배열 */
  users?: UserNameAndType[];
  /** 채팅의 주 대상이 되는(환자 or 의사) 유저의 ID */
  userID?: UserNameAndType;
  /** 채팅방 ID(_ID와 동일하고 _ID 사용 권장) */
  id?: string;
  /** 채팅방 _ID */
  _id: string;
  /** 채팅방 제목 */
  title?: string;
  /** 서비스매니저가 읽지 않은 채팅의 수 */
  n_UnreadCount?: number;
  /** 대상 유저가 읽지 않은 채팅의 수 */
  c_UnreadCount?: number;
  /** 채팅의 대상이 되는 유저가 처음 진입했는가에 대한 질의를 위한 플래그 */
  c_isFirstEnter?: boolean;
  /** 서비스 매니저의 첫 메세지 전송 여부 플래그 */
  c_isFirstNurseChat?: boolean;
  /** 대상 유저의 첫 메세지 구분 플래그 */
  c_isFirstUserChat?: boolean;
  /** 매니저의 첫 메세지 전송 이후를 확인하기 위한 플래그 */
  c_isSendedFirstNurseChat?: boolean;
  /** 해당 채팅방의 귀속 병원 ID */
  hospitalID?: string;
  /** 병원 계정과의 채팅방임을 구분짓는 플래그 */
  isDoctor?: boolean;
  /** 첫 메세지 전송을 통한 SMS 전송 여부 구분 플래그 */
  hasFirstSMS?: boolean;
  /** 마지막으로 전달된 메세지 모델 ID */
  lastMessage?: Chat;
  /** 마지막 메세지 전달 일시 */
  lastMessageUpdatedAt?: string;
  /** 채팅방 내에서의 총 메세지 수 */
  totalChatCount?: number;
  /** 마지막으로 환자가 전달한 채팅의 ObjectId */
  lastUserChat?: string;
  /** 마지막으로 환자가 전달한 채팅의 일시 */
  lastUserChatDate?: string;
  /** 마지막으로 환자가 아닌 유저가 전달한 채팅의 ObjectId */
  lastNurseChat?: string;
  /** 마지막으로 환자가 아닌 유저가 전달한 채팅의 일시 */
  lastNurseChatDate?: string;
  /** 참여 유저별 뱃지 카운트 정보 */
  badgeCountInfo?: Record<string, any>;
  /** 사용자 ID 별 필요한 정보의 집합 */
  info: {
    /**
     * 사용자 ID
     * @example "60b12345b1234c56789abcd1"
     */
    userID: string;
    /**
     * 채팅을 읽지 않은 갯수
     * @example 0
     */
    count: number;
    /**
     * 개인별 출력되는 채팅방 제목
     * @example "단체방"
     */
    title: string;
  }[];
  /** 1대1 채팅방 구분자 */
  isMultiUser?: boolean;
  /** 채팅방의 병원 응대 필요 (상담 요청) 여부 */
  isChatResponseRequired?: boolean;
  /** 병원 응대 필요 채팅 (상담 요청) 존재 여부 */
  hasUnreadChatResponseRequired?: boolean;
  /** 채팅방 삭제 여부 */
  isRemoved?: boolean;
  /** 채팅방 타입 정의 */
  roomType?: string;
  /** 카카오 상담톡을 위한 추가 정보 */
  ikakaoInfo?: Record<string, any>;
  /** 인스타그램 DM을 위한 추가 정보 */
  instagramInfo?: {
    /** 인스타그램 DM을 보낸 인스타그램 사용자 ID */
    senderID?: string;
    /** 인스타그램 DM을 받은 인스타그램 사용자 ID - 병원에 연동된 인스타그램 계정 중 하나의 인스타그램 사용자 ID */
    recipientID?: string;
    /**
     * 인스타그램 DM을 받은 병원에 연동된 인스타그램 로그인 ID
     * @example "@afterdoc.medipal"
     */
    inquiryTargetInstagramLoginID?: string;
    /** 인스타그램 DM이 닫혔는지 여부 */
    isClosed?: boolean;
    /**
     * 인스타그램 계정 인증 만료 일시. 연동되지 않은 경우 null
     * @format date-time
     */
    authorizationExpiresAt?: string | null;
    /** 인스타그램 계정 인증 만료까지 남은 일수. 연동되지 않은 경우 null */
    authorizationRemainingDays?: number | null;
    /**
     * 인스타그램 계정 비활성화 여부
     * @example false
     */
    isDeActivated?: boolean;
    /**
     * 인스타그램 계정 비활성화 유형 (예 PASSWORD_CHANGED)
     * @example null
     */
    deactivationType?: string | null;
  };
  /** 톡톡 채팅방 정보 */
  talktalkInfo?: {
    /** 톡톡 사용자 ID */
    talktalkUserId?: string;
    /** 톡톡 채팅방 이용 중단 여부 */
    isClosed?: boolean;
    /** 톡톡 고객 채팅방 이탈 확인 */
    isLeave?: boolean;
    /** 톡톡 연동 설정 값이 유효하지 않은 경우 채팅 발송 실패 시 해당 필드에 톡톡 인증 실패 여부 기록 */
    isUnauthorized?: boolean;
  };
  /** 라인 채팅방 정보 */
  lineInfo?: {
    /** 라인 사용자 ID */
    lineUserId?: string;
    /** 라인 채팅방 이용 중단 여부 */
    isClosed?: boolean;
    /** 라인 상담 맵 ID */
    lineConsultMapID?: string;
    /** 라인 채널 이름 */
    lineChannelName?: string;
    /** 라인 봇 ID */
    lineBotID?: string;
    /**
     * 라인 채팅방 종료 사유. 고객 차단(unfollow) 시 'userBlock'
     * @example "userBlock"
     */
    closedReason?: string;
  };
  /** 위챗 채팅방 정보 */
  wechatInfo?: {
    /** 채팅방으로 문의를 한 유저의 아이디 */
    userID?: string;
    /** 위챗 채널 이름 */
    channelName?: string;
    /** 위챗 채널 ID */
    channelID?: string;
    /** 위챗 채팅방 이용 중단 여부 */
    isClosed?: boolean;
    /**
     * 위챗 채팅방 종료 사유 (USER_UNSUBSCRIBED - 고객이 위챗 채널 언팔로우)
     * @example "USER_UNSUBSCRIBED"
     */
    closedReason?: "USER_UNSUBSCRIBED";
  };
  /** WhatsApp 채팅방 정보 */
  whatsappInfo?: {
    /** 채팅방으로 문의를 한 유저의 아이디 */
    userID?: string;
    /** 연동된 WhatsApp 계정 아이디 */
    channelID?: string;
    /** 연동된 WhatsApp 계정 이름 */
    channelName?: string;
    /** WhatsApp 채팅방 이용 중단 여부 */
    isClosed?: boolean;
    /** WhatsApp 채팅방 종료 사유. 환자 측 도달 불가(코드 131026) 시 'RECIPIENT_UNKNOWN' */
    closedReason?: "RECIPIENT_UNKNOWN";
  };
  /** 채팅방의 담당자 ID 배열 */
  counselors?: UserNameAndType[];
  /**
   * 상담 진행중 여부
   * @default false
   */
  isCounselInProgress?: boolean;
  /**
   * 번역 사용 여부
   * @default false
   */
  usingTranslation?: boolean;
  /** 언어 ObjectId */
  languageID?: LanguageNameAndAlpha2;
  /** 활성화 여부 */
  isActive?: boolean;
  /** 채팅방에 연결된 부모 서비스 ID. 연동된 내용이 없으면 hserviceID와 동일 */
  parentHServiceID: HService;
  /** ai 코치 정보 */
  aiCoach?: {
    /** 자동응대 사용 여부 */
    automaticResponseEnabled?: boolean;
    automaticResponseDisabledReason?: "APP_DISABLED" | "CHANNEL_DISABLED" | "CHATROOM_DISABLED";
    /** 현재 자동응대가 사용되고 있는지 여부 */
    isAutomaticResponseStopped?: boolean;
    /** 자동응대 정지 사유 (isAutomaticResponseStopped=true일 때만 존재) */
    automaticResponseStoppedReason?: "STAFF_REPLIED" | "HANDSOFF";
  };
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface HService {
  /** 서비스 ID */
  _id: string;
  /** 서비스 대상이 되는 유저 ID */
  userID: string;
  /** 서비스 대상의 이름 */
  name: string;
  /** 서비스 대상의 생년월일 */
  birth?: string;
  /** 서비스 대상의 전화번호 */
  phone: string;
  /** 서비스 대상의 성별 */
  gender?: string;
  /** 서비스 대상의 차트번호 */
  chartNumber?: string;
  /** 서비스 진행 매니저의 ID */
  nurseID?: string;
  /** 서비스 진행 매니저가 여럿인 경우의 매니저 ID 배열 */
  nurseIDs?: any[];
  /** 담당의 유저 ID */
  doctorID?: string;
  /** 서비스가 진행중인 병원의 ID */
  hospitalID: string;
  /** 서비스 내 포함된 채팅방 ID */
  chatRoomID?: string;
  /** 전능 대표 연동 고객번호 (유일) */
  ALCustomerNumber?: string;
  /** 전능 연동 고객번호 리스트 */
  ALCustomerNumbers?: any[];
  /** 서비스 내 작성된 모든 메모의 ID 배열 */
  memos?: any[];
  /** 매니저만 작성/열람 가능한 메모 ID 배열 */
  managementDiaries?: any[];
  /** 고객 태그 ObjectID 배열 */
  userTagIDs?: any[];
  /** 환자 설정 완료 여부(설정/미설정 수 count용) */
  hasPatientSetting?: boolean;
  /** 초기 치료내역 문자열 배열 */
  initialTreatments?: any[];
  /** 초기 치료내역 중  기타를 선택하고 입력한 내역 */
  etcTreatments?: string;
  /** 읽지 않은 매니저 메모의 존재 여부 */
  hasUnreadNurseMemo?: boolean;
  /** 읽지않은 병원 메모 존재 유무 */
  hasUnreadDoctorMemo?: boolean;
  /** 문자유입 프로세스를 통해 서비스를 시작한 경우 유입 Link */
  shortLinkID?: string;
  /** 링크형태의 웹을 통해 진입한 유저의 경우 Type */
  linkType?: string;
  /** 서비스 환자에 대한 간단 설명 */
  description?: string;
  /** 병원 계정의 경우  new 뱃지 표기를 위한 플래그 */
  new?: boolean;
  /** 가입 상태에 대한 string 플래그 */
  status?: string;
  /** query를 위한 서비스 시작 여부 플래그 */
  isRun: boolean;
  /** 모바일에서 환자가 서비스 이용 중단 요청한 경우, 시스템 또는 어드민 수준에서 특정 환자를 서비스 중단 처리한 경우 체크 플래그 */
  isClosed?: boolean;
  /** 서비스 종료시 사용자가 선택한 서비스 종료 이유. 혹은 병원에서 서비스를 종료한 후 사용자에게 보여주기 위한 문구. */
  closeReason: any[];
  /** 서비스 약관 동의 일시 (HService 기준) */
  agree_terms?: string;
  /** 개인정보 보호방침 동의 일시 (HService 기준) */
  agree_privacy?: string;
  /** 민감정보 관리방침 동의 일시 (HService 기준) */
  agree_sensitive?: string;
  /** 가입일시 */
  joinedAt?: string;
  /** 서비스 대상 유저의 마지막 로그인 일시 */
  lastLogin?: string;
  /** 마지막 유저의 채팅 모델 ID */
  lastUserChat?: string;
  /** 마지막 유저의 채팅 전송 일시 */
  lastUserChatDate?: string;
  /** 마지막 유저 채팅 존재 유무 */
  hasLastUserChat?: boolean;
  /** 마지막 매니저의 채팅 모델 ID */
  lastNurseChat?: string;
  /** 마지막 매니저의 채팅 전송 일시 */
  lastNurseChatDate?: string;
  /** 마지막 매니저 채팅 존재 유무 */
  hasLastNurseChat?: boolean;
  /** 채팅방에서 마지막으로 수신한 메세지 */
  lastMessage?: string;
  /** 마지막으로 수신된 메세지의 수신 일시 */
  lastMessageUpdatedAt?: string;
  /** 마지막 가입 문자 메시지 수신일자 */
  lastSMSDate?: string;
  /** 고객 유형(치료 유형) 카테고리 ID 목록 */
  treatmentCategories?: any[];
  /** 치료시작일 */
  treatmentStartDate?: string;
  /** 초진/재진 여부 */
  isFirstVisit?: boolean;
  /** 테스트 계정 여부. */
  isTest?: boolean;
  /** 예약만 등록 유저 여부 */
  isUnregisteredUser?: boolean;
  /** // 미가입 - 발송 예정인 기본 운동콘텐츠 목록 */
  reservedVCHIDs?: any[];
  /** 전송된 운동콘텐츠의 중 카테고리 ObjectID 배열. 누적 */
  vccIDs?: any[];
  /** 가장 최근에 운동콘텐츠가 전송된 날짜 */
  lastVCUDate?: string;
  /** 모든 운동콘텐츠가 종료되는 날짜 */
  lastVCUEndDate?: string;
  /** 직접 전송한 운동콘텐츠 유무. */
  hasVCU?: boolean;
  /** 병원에서 설정한 평균 이행률 이상 달성했는지 여부 */
  isOverHCompletionRate?: boolean;
  /** 운동콘텐츠 진행중 여부. */
  isVCUOngoing?: boolean;
  /** 합산 공유횟수(현재 반올림 하여 정수로 표현중이나  변경될 수 있음.) */
  sumShareCount?: number;
  /** 평균 이행률(현재 반올림 하여 정수로 저장하나  double 로 변경될 수 있음) */
  avgCompletionRate?: number;
  /** 운동콘텐츠 전송 필요 종모양 알람 표시 여부 */
  needVCU?: boolean;
  /** 운동콘텐츠 발송화면(Electron) 에서의 정렬을 위한 코드 */
  sortDigitVC?: string;
  /** 구분정보1 서비스 매니저가 고객별 입력 가능한 구분정보 */
  classificationNote1?: string;
  /** 구분정보2 서비스 매니저가 고객별 입력 가능한 구분정보 */
  classificationNote2?: string;
  /** 서비스 시작을 기준으로 카운팅되는 정수 인덱스 */
  seq?: number;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
  /** 서비스 시작일 */
  startedAt?: string;
}

export interface UserNameAndType {
  /** 유저 ID */
  _id: string;
  /** 이름 */
  name: string;
  /** 유저의 실제 이름 */
  realName: string;
  /** 유저 타입 */
  type: string;
  /** 유저의 직무 또는 직책 */
  jobType: string;
}

export interface Chat {
  /** 채팅 모델이 귀속된 채팅방 ID */
  chatRoomID?: string;
  /** 발송된 채팅 모델의 타입 */
  type?: number;
  /** 채팅 내 전달된 메세지 */
  content?: string;
  /** 채팅 내 전달된 메세지 (영어) */
  englishContent?: string;
  /** 번역된 메세지 */
  translatedContent?: string;
  /** 번역된 메세지를 재번역한 메세지 */
  retranslatedContent?: string;
  /** 번역 완료 여부 */
  isTranslated?: boolean;
  /** 채팅 발송 유저의 Type */
  userType?: number;
  /** 채팅을 발송한 유저의 ID */
  userID?: string;
  /** 첨부된 파일의 ID 배열 */
  fileIDs?: string;
  /** 채팅으로 전송된 운동콘텐츠 ID 배열 */
  videoContentIDs?: string[];
  /** 채팅으로 전송된 병원 이벤트 - 이벤트에 대한 ID */
  heventID?: string;
  /** 채팅으로 전송된 병원 이벤트 - 홈케어 상품에 대한 ID */
  haftercareID?: string;
  /** 채팅으로 전송된 병원 공지사항 ID */
  hnoticeID?: string;
  /** 채팅의 북마크 여부 */
  isBookmark?: boolean;
  /** 채팅의 북마크 지정 시간 */
  bookmarkedAt?: boolean;
  /** 채팅의 발송 성공 여부 */
  isSent?: boolean;
  /** 채팅의 발송 상태. success, failed 만 존재 */
  status?: string;
  /** 발송된 채팅 언어 */
  language?: string;
  /** 채팅의 삭제 여부 */
  isRemoved?: boolean;
  /** 미사용 */
  user?: Record<string, any>;
  /** 파일 전송 시  파일 업로드 이전에 임시로 생성된 경우에 사용될 ID */
  tempID?: string;
  /** 채팅 마커에 사용될 이모지 배열 */
  markers?: any[];
  /** 발송한 유저의 이름 */
  userName?: string;
  /** 채팅 발신자의 직책 */
  jobType?: string;
  /** 유저의 실제 이름 */
  userRealName?: string;
  /** 발송한 유저의 프로필 이미지 URL */
  photoPath?: string;
  /** 상담 알고리즘의 Identifier (임시) */
  caName?: string;
  /** 상담 알고리즘의 사이클 Identifier */
  caCycle?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
  /** 채팅 삭제일시 */
  removedAt?: string;
  /** 채팅 전송일시. 애프터닥 채팅인 경우 생성일시와 발송일시 동일 */
  sentAt?: string;
  /** 채팅 전송 실패 일시. 실패했을 경우 기록 */
  failedAt?: string;
}

export interface LanguageNameAndAlpha2 {
  /** 언어 명칭 (한국어) */
  koreanLanguageName: string;
  /** 언어 명칭 (영어) */
  englishLanguageName: string;
  /** ISO 639-1 기반 2글자 영문 고유 부호 */
  languageCodeISOAlpha2: string;
}

export interface ChatRoom {
  /** 채팅방에 참여중인 서비스 ID */
  hserviceID?: string;
  /** 채팅방에 참여중인(Push notification을 받아야 하는.) 유저의 ID 배열 */
  users?: any[];
  /** 채팅의 주 대상이 되는(환자 or 의사) 유저의 ID */
  userID?: string;
  /** 채팅방 ID(_ID와 동일하고 _ID 사용 권장) */
  id?: string;
  /** 채팅방 _ID */
  _id: string;
  /** 채팅방 제목 */
  title?: string;
  /** 서비스매니저가 읽지 않은 채팅의 수 */
  n_UnreadCount?: number;
  /** 대상 유저가 읽지 않은 채팅의 수 */
  c_UnreadCount?: number;
  /** 채팅의 대상이 되는 유저가 처음 진입했는가에 대한 질의를 위한 플래그 */
  c_isFirstEnter?: boolean;
  /** 서비스 매니저의 첫 메세지 전송 여부 플래그 */
  c_isFirstNurseChat?: boolean;
  /** 대상 유저의 첫 메세지 구분 플래그 */
  c_isFirstUserChat?: boolean;
  /** 매니저의 첫 메세지 전송 이후를 확인하기 위한 플래그 */
  c_isSendedFirstNurseChat?: boolean;
  /** 해당 채팅방의 귀속 병원 ID */
  hospitalID?: string;
  /** 병원 계정과의 채팅방임을 구분짓는 플래그 */
  isDoctor?: boolean;
  /** 첫 메세지 전송을 통한 SMS 전송 여부 구분 플래그 */
  hasFirstSMS?: boolean;
  /** 마지막으로 전달된 메세지 모델 ID */
  lastMessage?: string;
  /** 마지막 메세지 전달 일시 */
  lastMessageUpdatedAt?: string;
  /** 채팅방 내에서의 총 메세지 수 */
  totalChatCount?: number;
  /** 마지막으로 환자가 전달한 채팅의 ObjectId */
  lastUserChat?: string;
  /** 마지막으로 환자가 전달한 채팅의 일시 */
  lastUserChatDate?: string;
  /** 마지막으로 환자가 아닌 유저가 전달한 채팅의 ObjectId */
  lastNurseChat?: string;
  /** 마지막으로 환자가 아닌 유저가 전달한 채팅의 일시 */
  lastNurseChatDate?: string;
  /** 참여 유저별 뱃지 카운트 정보 */
  badgeCountInfo?: Record<string, any>;
  /** 사용자 ID 별 필요한 정보의 집합 */
  info: {
    /**
     * 사용자 ID
     * @example "60b12345b1234c56789abcd1"
     */
    userID: string;
    /**
     * 채팅을 읽지 않은 갯수
     * @example 0
     */
    count: number;
    /**
     * 개인별 출력되는 채팅방 제목
     * @example "단체방"
     */
    title: string;
  }[];
  /** 1대1 채팅방 구분자 */
  isMultiUser?: boolean;
  /** 채팅방의 병원 응대 필요 (상담 요청) 여부 */
  isChatResponseRequired?: boolean;
  /** 병원 응대 필요 채팅 (상담 요청) 존재 여부 */
  hasUnreadChatResponseRequired?: boolean;
  /** 채팅방 삭제 여부 */
  isRemoved?: boolean;
  /** 채팅방 타입 정의 */
  roomType?: string;
  /** 카카오 상담톡을 위한 추가 정보 */
  ikakaoInfo?: Record<string, any>;
  /** 채팅방의 담당자 ID 배열 */
  counselors?: any[];
  /**
   * 상담 진행중 여부
   * @default false
   */
  isCounselInProgress?: boolean;
  /**
   * 번역 사용 여부
   * @default false
   */
  usingTranslation?: boolean;
  /** 언어 ObjectId */
  languageID?: string;
  /** 활성화 여부 */
  isActive?: boolean;
  /** 채팅방에 연결된 부모 서비스 ID. 연동된 내용이 없으면 hserviceID와 동일 */
  parentHServiceID: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface ChatRoomControllerPaginationResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    chatrooms: {
      id: string;
      title: string;
      /** 채널 타입 */
      platformType: "instagram" | "talktalk" | "ikakao" | "wechat" | "whatsapp" | "patient" | "line";
      platformChannelName?: string;
      customerID: string;
      lastMessage?: {
        _id: string;
        content: string;
        userType: string;
        type: string;
        translatedContent?: string;
        retranslatedContent?: string;
        isTranslated?: boolean;
        isSendContent?: boolean;
        /** @format date */
        sentAt: string;
        /** @format date */
        createdAt: string;
        matched?: {
          text: string;
          ranges: {
            start: number;
            end: number;
          }[];
        };
      } | null;
      counselors: {
        userID: string;
        realName: string;
      }[];
      inProgress: boolean;
      isRead: boolean;
      isActive: boolean;
      isClosed: boolean;
      isImportant: boolean;
      isAnswered: boolean;
      isLeave: boolean;
      hserviceID?: string;
      parentHServiceID?: string;
      chatroomAdditionalInfo?: {
        name?: string;
        chartNumber?: string;
        birth?: string;
        phone?: string;
        countryCode?: {
          id?: string;
          koreanCountryName: string;
          englishCountryName: string;
          internationalDialingCodes: string;
        } | null;
      };
      /** 그룹별 고객 태그 정보 (태그가 없으면 빈 객체) */
      customTags: Record<
        string,
        {
          id: string;
          name: string;
          tags: {
            id: string;
            name: string;
          }[];
        }
      >;
    }[];
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ChatRoomControllerPaginationCountResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 진행중인 채팅방 개수 */
    inProgress: number;
    /** 상담완료 채팅방 개수 */
    completed: number;
    /** 중요 채팅방 개수 */
    important: number;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ChatRoomControllerUnreadCountResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 직원(상담자) userID */
    _id: string;
    /** 안 읽은 채팅 수 */
    total: number;
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ChatRoomControllerToggleTranslateBodyRequest {
  /** 채팅방 ID */
  chatRoomID: string;
  /** 번역 사용 여부 */
  usingTranslation: boolean;
}

export interface ChatRoomControllerToggleTranslateResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 채팅방 ID */
    chatRoomID: string;
    /** 번역 사용 여부 */
    usingTranslation: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ChatRoomControllerToggleTranslateCheckBodyRequest {
  /** 채팅방 ID */
  chatRoomID: string;
  /** 번역 검수 사용 여부 */
  isUsingTranslateInspection: boolean;
}

export interface ChatRoomControllerToggleTranslateCheckResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 채팅방 ID */
    chatRoomID: string;
    /** 번역 검수 사용 여부 */
    isUsingTranslateInspection: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ChatRoomControllerUpdateTranslateLanguageBodyRequest {
  /** 채팅방 ID */
  chatRoomID: string;
  /** 언어 ID */
  languageID: string;
}

export interface ChatRoomControllerUpdateTranslateLanguageResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 채팅방 ID */
    chatRoomID: string;
    /** 언어 ID */
    languageID: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ChatRoomControllerFindTranslateLanguageListResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 언어 ID */
    _id: string;
    /** 언어 코드 */
    languageCodeISOAlpha2: string;
    /** 한국어 언어명 */
    koreanLanguageName: string;
    /** 영어 언어명 */
    englishLanguageName: string;
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ChatRoomControllerAddCounselorsBodyRequest {
  /** 채팅방 ID */
  chatRoomID: string;
  /** 추가하고자 하는 담당자의 userID 배열 */
  counselors: string[];
}

export interface ChatRoomControllerAddCounselorsResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 수정된 채팅방 객체 */
    chatRoom?: any;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ChatRoomControllerFindOneResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  /** 채팅방 객체 (HService/LastMessage/Users populate, customTagGroups, instagramInfo.authorizationRemainingDays/authorizationExpiresAt 포함). null 가능 (chatRoomID 미존재 시) */
  data: Record<string, any> | null;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ChatRoomControllerMarkAsReadBodyRequest {
  /** 읽음 처리할 채팅방 ID */
  chatRoomID: string;
}

export interface ChatRoomControllerMarkAsReadResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  /** 읽음 처리된 채팅방 객체 (userID/users/counselors/hserviceID/parentHServiceID/lastMessage/languageID populate). chatRoomID 가 없으면 null */
  data: Record<string, any> | null;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface MSOChatRoomControllerMsoUnreadCountResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: Record<string, number>;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ChatRoomELPaginationHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 전체 채팅방 개수 */
    totalCount: number;
    chatrooms: {
      id: string;
      title: string;
      /** 채널 타입: instagram(인스타그램), talktalk(톡톡), ikakao(카카오), wechat(위챗), whatsapp(왓츠앱), patient(환자), line(라인) */
      platformType: "instagram" | "talktalk" | "ikakao" | "wechat" | "whatsapp" | "patient" | "line";
      platformChannelName?: string;
      customerID: string;
      lastMessage?: {
        _id: string;
        content: string;
        userType: string;
        type: string;
        translatedContent?: string;
        retranslatedContent?: string;
        isTranslated?: boolean;
        isSendContent?: boolean;
        /** @format date */
        sentAt: string;
        /** @format date */
        createdAt: string;
      } | null;
      counselors: {
        userID: string;
        realName: string;
      }[];
      inProgress: boolean;
      isRead: boolean;
      isActive: boolean;
      isClosed: boolean;
      isImportant: boolean;
      isAnswered: boolean;
      isLeave: boolean;
      hserviceID?: string;
      parentHServiceID?: string;
      chatroomAdditionalInfo?: {
        name?: string;
        chartNumber?: string;
        birth?: string;
        phone?: string;
        countryCode?: {
          id?: string;
          koreanCountryName: string;
          englishCountryName: string;
          internationalDialingCodes: string;
        } | null;
      };
      /** 그룹별 고객 태그 정보 (태그가 없으면 빈 객체) */
      customTags: Record<
        string,
        {
          id: string;
          name: string;
          tags: {
            id: string;
            name: string;
          }[];
        }
      >;
    }[];
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ChatRoomELPaginationCountHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 진행중인 채팅방 개수 */
    inProgress: number;
    /** 상담완료 채팅방 개수 */
    completed: number;
    /** 중요 채팅방 개수 */
    important: number;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ChatRoomHMPaginationHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 전체 채팅방 개수 */
    totalCount: number;
    chatrooms: {
      id: string;
      title: string;
      /** 채널 타입: instagram(인스타그램), talktalk(톡톡), ikakao(카카오), wechat(위챗), whatsapp(왓츠앱), patient(환자), line(라인) */
      platformType: "instagram" | "talktalk" | "ikakao" | "wechat" | "whatsapp" | "patient" | "line";
      platformChannelName?: string;
      customerID: string;
      lastMessage?: {
        _id: string;
        content: string;
        userType: string;
        type: string;
        translatedContent?: string;
        retranslatedContent?: string;
        isTranslated?: boolean;
        isSendContent?: boolean;
        /** @format date */
        sentAt: string;
        /** @format date */
        createdAt: string;
      } | null;
      counselors: {
        userID: string;
        realName: string;
      }[];
      inProgress: boolean;
      isRead: boolean;
      isActive: boolean;
      isClosed: boolean;
      isImportant: boolean;
      isAnswered: boolean;
      isLeave: boolean;
      hserviceID?: string;
      parentHServiceID?: string;
      chatroomAdditionalInfo?: {
        name?: string;
        chartNumber?: string;
        birth?: string;
        phone?: string;
        countryCode?: {
          id?: string;
          koreanCountryName: string;
          englishCountryName: string;
          internationalDialingCodes: string;
        } | null;
      };
      /** 그룹별 고객 태그 정보 (태그가 없으면 빈 객체) */
      customTags: Record<
        string,
        {
          id: string;
          name: string;
          tags: {
            id: string;
            name: string;
          }[];
        }
      >;
    }[];
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ChatRoomHMPaginationCountHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 진행중인 채팅방 개수 */
    inProgress: number;
    /** 상담완료 채팅방 개수 */
    completed: number;
    /** 중요 채팅방 개수 */
    important: number;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ChatRoomMUpdateHandlerBodyRequest {
  /** MongoDB Identifier */
  _id: string;
  hserviceID: string;
  users?: string[];
  userID: string;
  title: string;
  n_UnreadCount: number;
  c_UnreadCount: number;
  c_isFirstEnter: boolean;
  c_isFirstNurseChat: boolean;
  c_isFirstUserChat: boolean;
  c_isSendedFirstNursechat: boolean;
  hospitalID: string;
  isDoctor: boolean;
  hasFirstSMS: boolean;
  lastMessage?: string;
  /** @format date */
  lastMessageUpdatedAt?: string;
  lastNurseChat?: string;
  /** @format date */
  lastNurseChatUpdatedAt?: string;
  badgeCountInfo?: Record<string, number>;
  info?: {
    userID: string;
    count: number;
    title: string;
  }[];
  isMultiUser?: boolean;
  isChatResponseRequired?: boolean;
  hasUnreadChatResponseRequired?: boolean;
  isRemoved?: boolean;
  roomType?: "patient" | "manager" | "ikakao" | "instagram" | "talktalk" | "line" | "wechat" | "whatsapp";
  ikakaoinfo?: {
    pf_id?: string;
    user_key?: string;
    isClosed?: boolean;
    isUnauthorized?: boolean;
  };
  lineInfo?: {
    lineUserId?: string;
    isClosed?: boolean;
    closedReason?: string;
    lineConsultMapID?: string;
    lineChannelName?: string;
    lineBotID?: string;
  };
  wechatInfo?: {
    channelID?: string;
    channelName?: string;
    userID?: string;
    isClosed?: boolean;
    closedReason?: "USER_UNSUBSCRIBED";
  };
  counselors?: string[];
  isCounselInProgress?: boolean;
  usingTranslation?: boolean;
  languageID?: string;
  isActive?: boolean;
  parentHServiceID?: string;
  isClosed?: boolean;
  /** @format date */
  createdAt: string;
  /** @format date */
  updatedAt: string;
}

export interface ChatRoomMUpdateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    hserviceID: string;
    users?: string[];
    userID: string;
    title: string;
    n_UnreadCount: number;
    c_UnreadCount: number;
    c_isFirstEnter: boolean;
    c_isFirstNurseChat: boolean;
    c_isFirstUserChat: boolean;
    c_isSendedFirstNursechat: boolean;
    hospitalID: string;
    isDoctor: boolean;
    hasFirstSMS: boolean;
    lastMessage?: string;
    /** @format date */
    lastMessageUpdatedAt?: string;
    lastNurseChat?: string;
    /** @format date */
    lastNurseChatUpdatedAt?: string;
    badgeCountInfo?: Record<string, number>;
    info?: {
      userID: string;
      count: number;
      title: string;
    }[];
    isMultiUser?: boolean;
    isChatResponseRequired?: boolean;
    hasUnreadChatResponseRequired?: boolean;
    isRemoved?: boolean;
    roomType?: "patient" | "manager" | "ikakao" | "instagram" | "talktalk" | "line" | "wechat" | "whatsapp";
    ikakaoinfo?: {
      pf_id?: string;
      user_key?: string;
      isClosed?: boolean;
      isUnauthorized?: boolean;
    };
    lineInfo?: {
      lineUserId?: string;
      isClosed?: boolean;
      closedReason?: string;
      lineConsultMapID?: string;
      lineChannelName?: string;
      lineBotID?: string;
    };
    wechatInfo?: {
      channelID?: string;
      channelName?: string;
      userID?: string;
      isClosed?: boolean;
      closedReason?: "USER_UNSUBSCRIBED";
    };
    counselors?: string[];
    isCounselInProgress?: boolean;
    usingTranslation?: boolean;
    languageID?: string;
    isActive?: boolean;
    parentHServiceID?: string;
    isClosed?: boolean;
    /** @format date */
    createdAt: string;
    /** @format date */
    updatedAt: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ChatRoomMFindOneHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    hserviceID: string;
    users?: string[];
    userID: string;
    title: string;
    n_UnreadCount: number;
    c_UnreadCount: number;
    c_isFirstEnter: boolean;
    c_isFirstNurseChat: boolean;
    c_isFirstUserChat: boolean;
    c_isSendedFirstNursechat: boolean;
    hospitalID: string;
    isDoctor: boolean;
    hasFirstSMS: boolean;
    lastMessage?: string;
    /** @format date */
    lastMessageUpdatedAt?: string;
    lastNurseChat?: string;
    /** @format date */
    lastNurseChatUpdatedAt?: string;
    badgeCountInfo?: Record<string, number>;
    info?: {
      userID: string;
      count: number;
      title: string;
    }[];
    isMultiUser?: boolean;
    isChatResponseRequired?: boolean;
    hasUnreadChatResponseRequired?: boolean;
    isRemoved?: boolean;
    roomType?: "patient" | "manager" | "ikakao" | "instagram" | "talktalk" | "line" | "wechat" | "whatsapp";
    ikakaoinfo?: {
      pf_id?: string;
      user_key?: string;
      isClosed?: boolean;
      isUnauthorized?: boolean;
    };
    lineInfo?: {
      lineUserId?: string;
      isClosed?: boolean;
      closedReason?: string;
      lineConsultMapID?: string;
      lineChannelName?: string;
      lineBotID?: string;
    };
    wechatInfo?: {
      channelID?: string;
      channelName?: string;
      userID?: string;
      isClosed?: boolean;
      closedReason?: "USER_UNSUBSCRIBED";
    };
    counselors?: string[];
    isCounselInProgress?: boolean;
    usingTranslation?: boolean;
    languageID?: string;
    isActive?: boolean;
    parentHServiceID?: string;
    isClosed?: boolean;
    /** @format date */
    createdAt: string;
    /** @format date */
    updatedAt: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ChatRoomMUpdateReadHandlerBodyRequest {
  _id: string;
}

export interface ChatRoomMUpdateReadHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    hserviceID: string;
    users?: string[];
    userID: string;
    title: string;
    n_UnreadCount: number;
    c_UnreadCount: number;
    c_isFirstEnter: boolean;
    c_isFirstNurseChat: boolean;
    c_isFirstUserChat: boolean;
    c_isSendedFirstNursechat: boolean;
    hospitalID: string;
    isDoctor: boolean;
    hasFirstSMS: boolean;
    lastMessage?: string;
    /** @format date */
    lastMessageUpdatedAt?: string;
    lastNurseChat?: string;
    /** @format date */
    lastNurseChatUpdatedAt?: string;
    badgeCountInfo?: Record<string, number>;
    info?: {
      userID: string;
      count: number;
      title: string;
    }[];
    isMultiUser?: boolean;
    isChatResponseRequired?: boolean;
    hasUnreadChatResponseRequired?: boolean;
    isRemoved?: boolean;
    roomType?: "patient" | "manager" | "ikakao" | "instagram" | "talktalk" | "line" | "wechat" | "whatsapp";
    ikakaoinfo?: {
      pf_id?: string;
      user_key?: string;
      isClosed?: boolean;
      isUnauthorized?: boolean;
    };
    lineInfo?: {
      lineUserId?: string;
      isClosed?: boolean;
      closedReason?: string;
      lineConsultMapID?: string;
      lineChannelName?: string;
      lineBotID?: string;
    };
    wechatInfo?: {
      channelID?: string;
      channelName?: string;
      userID?: string;
      isClosed?: boolean;
      closedReason?: "USER_UNSUBSCRIBED";
    };
    counselors?: string[];
    isCounselInProgress?: boolean;
    usingTranslation?: boolean;
    languageID?: string;
    isActive?: boolean;
    parentHServiceID?: string;
    isClosed?: boolean;
    /** @format date */
    createdAt: string;
    /** @format date */
    updatedAt: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ChatRoomELFindServiceInformationHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    hserviceID: string;
    name: string;
    isFirstVisit?: boolean;
    chartNumber?: string;
    hasKakao?: boolean;
    hasInstagram?: boolean;
    hasTalkTalk?: boolean;
    hasLine?: boolean;
    hasWechat?: boolean;
    hasWhatsapp?: boolean;
    isGrayAfterDoc?: boolean;
    isColorAfterDoc?: boolean;
    gender?: string;
    birth?: string;
    phone?: string;
    countryCode?: {
      _id?: string;
      koreanCountryName?: string;
      internationalDialingCodes?: string;
    } | null;
    treatmentCategories?:
      | {
          tagId?: string;
          name?: string;
          color?: string;
          automationApplied?: boolean;
        }[]
      | null;
    automationAppliedTreatmentTag?: {
      tagId?: string;
      name?: string;
      color?: string;
      automationApplied?: boolean;
    } | null;
    closeReason?: string[] | null;
    hasSmartDoctorLinkage?: boolean;
    nationality?: {
      _id?: string;
      koreanCountryName?: string;
      internationalDialingCodes?: string;
    } | null;
    /** 인스타그램 문의 대상 계정 아이디 - 병원 내 연동된 인스타그램 계정 */
    inquiryTargetInstagramLoginID?: string | null;
    /** 톡톡 문의 대상 계정 아이디 - 병원 내 연동된 톡톡 계정 */
    inquiryTargetTalktalkUserID?: string | null;
    /** 라인 문의 대상 계정 아이디 - 병원 내 연동된 라인 계정 */
    inquiryTargetLineUserID?: string | null;
    /** 왓츠앱 문의 대상 계정 이름 - 병원 내 연동된 왓츠앱 계정 */
    inquiryTargetWhatsappUserID?: string | null;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ChatRoomHMFindServiceInformationHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    hserviceID: string;
    name: string;
    isFirstVisit?: boolean;
    chartNumber?: string;
    hasKakao?: boolean;
    hasInstagram?: boolean;
    hasTalkTalk?: boolean;
    hasLine?: boolean;
    hasWechat?: boolean;
    hasWhatsapp?: boolean;
    isGrayAfterDoc?: boolean;
    isColorAfterDoc?: boolean;
    gender?: string;
    birth?: string;
    phone?: string;
    countryCode?: {
      _id?: string;
      koreanCountryName?: string;
      internationalDialingCodes?: string;
    } | null;
    treatmentCategories?:
      | {
          tagId?: string;
          name?: string;
          color?: string;
          automationApplied?: boolean;
        }[]
      | null;
    automationAppliedTreatmentTag?: {
      tagId?: string;
      name?: string;
      color?: string;
      automationApplied?: boolean;
    } | null;
    closeReason?: string[] | null;
    hasSmartDoctorLinkage?: boolean;
    nationality?: {
      _id?: string;
      koreanCountryName?: string;
      internationalDialingCodes?: string;
    } | null;
    /** 인스타그램 문의 대상 계정 아이디 - 병원 내 연동된 인스타그램 계정 */
    inquiryTargetInstagramLoginID?: string | null;
    /** 라인 채널 이름 - 병원 내 연동된 라인 계정 */
    lineChannelName?: string | null;
    /** 왓츠앱 채널 이름 - 병원 내 연동된 왓츠앱 계정 */
    whatsappChannelName?: string | null;
    isImportant?: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ChatRoomELStarChatroomHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    success: boolean;
    message?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ChatRoomHMStarChatroomHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    success: boolean;
    message?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ApiChatroomElFindParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 관리자 채팅 여부 */
  isDoctor?: boolean;
  /** 삭제 여부 */
  isRemoved?: boolean;
  /** 1대1 채팅방 구분자 */
  isMultiUser?: boolean;
  /** 상담 진행중 여부 */
  isCounselInProgress?: boolean;
  /** 채팅방 활성화 여부. 사용자의 마지막 채팅이 온 것을 기준으로 갱신 */
  isActive?: boolean;
  /** 읽지 않은 순으로 정렬 사용 여부 */
  isSortByUnread?: boolean;
  /** 검색 키워드 - 환자 채팅방 제목 또는 관리자 채팅방 개별 제목 검색 */
  keyword?: string;
  /** 참여하고 있는 채팅방 조회 시 사용할 userID. 모든 권한이 조회 시 빈값으로 조회 */
  participant?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number;
}

export type ApiChatroomElFindData = ApiResponse & {
  data: ChatRoomHServiceLastMessageUsers[];
};

export interface ApiChatroomElFindOneParams {
  /** (required) 채팅방 ID */
  chatRoomID?: string;
}

export type ApiChatroomElFindOneData = ApiResponse & {
  data: ChatRoomHServiceLastMessageUsers & {
    /**
     * 채팅방 번역 사용 여부
     * @example false
     */
    usingTranslation?: boolean;
    /**
     * 채팅방 번역 검수 사용 여부
     * @example false
     */
    isUsingTranslateInspection?: boolean;
    /** 인스타그램 DM을 위한 추가 정보 */
    instagramInfo?: {
      /** 인스타그램 DM을 보낸 인스타그램 사용자 ID */
      senderID?: string;
      /** 인스타그램 DM을 받은 인스타그램 사용자 ID - 병원에 연동된 인스타그램 계정 중 하나의 인스타그램 사용자 ID */
      recipientID?: string;
      /**
       * 인스타그램 DM을 받은 병원에 연동된 인스타그램 로그인 ID
       * @example "@afterdoc.medipal"
       */
      inquiryTargetInstagramLoginID?: string;
      /** 인스타그램 DM이 닫혔는지 여부 */
      isClosed?: boolean;
      /**
       * 인증 만료 잔여 일 수
       * @example 30
       */
      authorizationRemainingDays?: number | null;
      /**
       * 인증 만료 일시
       * @format date-time
       * @example "2025-02-01T00:00:00.000Z"
       */
      authorizationExpiresAt?: string | null;
      /**
       * 인스타그램 계정 비활성화 여부
       * @example false
       */
      isDeActivated?: boolean;
      /**
       * 인스타그램 계정 비활성화 유형 (예 PASSWORD_CHANGED)
       * @example null
       */
      deactivationType?: string | null;
    };
  };
};

export interface ApiChatroomElCountParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 관리자 채팅 여부 */
  isDoctor?: boolean;
  /** 삭제 여부 */
  isRemoved?: boolean;
  /** 1대1 채팅방 구분자 */
  isMultiUser?: boolean;
  /** 상담 진행중 여부 */
  isCounselInProgress?: boolean;
  /** 채팅방 활성화 여부. 사용자의 마지막 채팅이 온 것을 기준으로 갱신 */
  isActive?: boolean;
  /** 검색 키워드 - 환자 채팅방 제목 검색 */
  keyword?: string;
  /** 참여하고 있는 채팅방 조회 시 사용할 userID. 모든 권한이 조회 시 빈값으로 조회 */
  participant?: string;
}

export type ApiChatroomElCountData = ApiResponse & {
  data: number;
};

export interface ApiChatroomElUnreadcountParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 유저 아이디 */
  userID?: string;
  /** 관리자 채팅방 여부 */
  isDoctor?: boolean;
  /** 채팅방 활성화 여부 */
  isActive?: boolean;
  /** 상담 진행 여부 */
  isCounselInProgress?: boolean;
}

export type ApiChatroomElUnreadcountData = ApiResponse & {
  data: {
    /** userID */
    _id: string;
    /** 안 읽은 채팅 수. */
    total: number;
  }[];
};

export type ApiChatroomElUpdateData = ApiResponse & {
  data: ChatRoomHServiceLastMessageUsers;
};

export type ApiChatroomElUpdateReadData = ApiResponse & {
  data: ChatRoomHServiceLastMessageUsers;
};

export type ApiChatroomElUpdateCounselStatusData = ApiResponse & {
  data: ChatRoomHServiceLastMessageUsers;
};

export type ApiChatroomElUpdateCounselCounselorData = ApiResponse & {
  data: ChatRoomHServiceLastMessageUsers;
};

export type ApiChatroomElUserAddData = ApiResponse & {
  data: ChatRoomHServiceLastMessageUsers;
};

export type ApiChatroomElUserRemoveData = ApiResponse & {
  data: ChatRoomHServiceLastMessageUsers;
};

export type ApiChatroomElUserRemoveAllData = ApiResponse & {
  data: ChatRoom[];
};

export type ApiChatroomElCounselorAddData = ApiResponse & {
  data: ChatRoomHServiceLastMessageUsers;
};

export type ApiChatroomElDetectLanguageData = ApiResponse & {
  data: LanguageNameAndAlpha2;
};

export type ApiChatroomElUpdateTranslateToggleData = ApiResponse & {
  data: ChatRoom;
};

export interface ApiChatroomHmFindParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 관리자 채팅 여부 */
  isDoctor?: boolean;
  /** 삭제 여부 */
  isRemoved?: boolean;
  /** 1대1 채팅방 구분자 */
  isMultiUser?: boolean;
  /** 상담 진행중 여부 */
  isCounselInProgress?: boolean;
  /** 채팅방 활성화 여부. 사용자의 마지막 채팅이 온 것을 기준으로 갱신 */
  isActive?: boolean;
  /** 읽지 않은 순으로 정렬 사용 여부 */
  isSortByUnread?: boolean;
  /** 검색 키워드 - 환자 채팅방 제목 또는 관리자 채팅방 개별 제목 검색 */
  keyword?: string;
  /** 참여하고 있는 채팅방 조회 시 사용할 userID. 모든 권한이 조회 시 빈값으로 조회 */
  participant?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number;
}

export type ApiChatroomHmFindData = ApiResponse & {
  data: ChatRoomHServiceLastMessageUsers[];
};

export interface ApiChatroomHmFindOneParams {
  /** (required) 채팅방 ID */
  chatRoomID?: string;
}

export type ApiChatroomHmFindOneData = ApiResponse & {
  data: ChatRoomHServiceLastMessageUsers & {
    /**
     * 채팅방 번역 사용 여부
     * @example false
     */
    usingTranslation?: boolean;
    /**
     * 채팅방 번역 검수 사용 여부
     * @example false
     */
    isUsingTranslateInspection?: boolean;
    /** 인스타그램 DM을 위한 추가 정보 */
    instagramInfo?: {
      /** 인스타그램 DM을 보낸 인스타그램 사용자 ID */
      senderID?: string;
      /** 인스타그램 DM을 받은 인스타그램 사용자 ID - 병원에 연동된 인스타그램 계정 중 하나의 인스타그램 사용자 ID */
      recipientID?: string;
      /**
       * 인스타그램 DM을 받은 병원에 연동된 인스타그램 로그인 ID
       * @example "@afterdoc.medipal"
       */
      inquiryTargetInstagramLoginID?: string;
      /** 인스타그램 DM이 닫혔는지 여부 */
      isClosed?: boolean;
      /**
       * 인증 만료 잔여 일 수
       * @example 30
       */
      authorizationRemainingDays?: number | null;
      /**
       * 인증 만료 일시
       * @format date-time
       * @example "2025-02-01T00:00:00.000Z"
       */
      authorizationExpiresAt?: string | null;
      /**
       * 인스타그램 계정 비활성화 여부
       * @example false
       */
      isDeActivated?: boolean;
      /**
       * 인스타그램 계정 비활성화 유형 (예: PASSWORD_CHANGED)
       * @example null
       */
      deactivationType?: string | null;
    };
  };
};

export interface ApiChatroomHmCountParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 관리자 채팅 여부 */
  isDoctor?: boolean;
  /** 삭제 여부 */
  isRemoved?: boolean;
  /** 1대1 채팅방 구분자 */
  isMultiUser?: boolean;
  /** 상담 진행중 여부 */
  isCounselInProgress?: boolean;
  /** 채팅방 활성화 여부. 사용자의 마지막 채팅이 온 것을 기준으로 갱신 */
  isActive?: boolean;
  /** 검색 키워드 - 환자 채팅방 제목 검색 */
  keyword?: string;
  /** 참여하고 있는 채팅방 조회 시 사용할 userID. 모든 권한이 조회 시 빈값으로 조회 */
  participant?: string;
}

export type ApiChatroomHmCountData = ApiResponse & {
  data: number;
};

export interface ApiChatroomHmUnreadcountParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** 유저 아이디 */
  userID?: string;
  /** 관리자 채팅방 여부 */
  isDoctor?: boolean;
  /** 채팅방 활성화 여부 */
  isActive?: boolean;
  /** 상담 진행 여부 */
  isCounselInProgress?: boolean;
}

export type ApiChatroomHmUnreadcountData = ApiResponse & {
  data: {
    /** userID */
    _id: string;
    /** 안 읽은 채팅 수. */
    total: number;
  }[];
};

export type ApiChatroomHmUpdateData = ApiResponse & {
  data: ChatRoomHServiceLastMessageUsers;
};

export type ApiChatroomHmUpdateReadData = ApiResponse & {
  data: ChatRoomHServiceLastMessageUsers;
};

export type ApiChatroomHmUpdateCounselStatusData = ApiResponse & {
  data: ChatRoomHServiceLastMessageUsers;
};

export type ApiChatroomHmUserRemoveData = ApiResponse & {
  data: ChatRoomHServiceLastMessageUsers;
};

export type ApiChatroomHmCounselorAddData = ApiResponse & {
  data: ChatRoomHServiceLastMessageUsers;
};

export type ApiChatroomHmUpdateTranslateToggleData = ApiResponse & {
  data: ChatRoom;
};

export interface ChatRoomControllerPaginationParams {
  /** 카테고리: inProgress(진행중), completed(상담완료), important(중요) */
  category: "inProgress" | "completed" | "important";
  /** 필터: total(전체), unread(읽지않음), unanswered(답변안함), answered(답변함) */
  filter?: "total" | "unread" | "unanswered" | "answered";
  /**
   * 채널별 ID 필터 (JSON 문자열): 각 채팅 타입별로 ID 배열 전달. 복수 선택 시 OR 조건으로 작동
   * @example "{"line":["lineBotID1"],"instagram":["instagramLoginID1"],"patient":[]}"
   */
  channels?: string;
  /** 검색 키워드 타입: patientName(환자명), phoneNumber(전화번호), counselorName(담당자명), chartNumber(차트번호), customTag(고객태그), datePeriod(기간), content(메시지 본문) */
  keyword?: "patientName" | "phoneNumber" | "counselorName" | "chartNumber" | "customTag" | "datePeriod" | "content";
  /**
   * 검색할 값 (keyword와 함께 사용; datePeriod 일 때는 무시되고 startDate/endDate 를 사용)
   * @example "김민재"
   */
  keywordValue?: string;
  /**
   * 고객 태그 그룹 ID
   * @example "customTagGroupID1"
   */
  customTagGroupID?: string;
  /**
   * 기간 검색 시작 (ISO 8601, keyword=datePeriod 일 때만 사용)
   * @example "2026-01-01T00:00:00Z"
   */
  startDate?: string;
  /**
   * 기간 검색 종료 (ISO 8601, keyword=datePeriod 일 때만 사용)
   * @example "2026-05-13T23:59:59Z"
   */
  endDate?: string;
  /**
   * 정렬 타입: latestAll(기본; 마지막 메시지 최신 순), newInquiry(환자 메시지 최신 순), longestWait(환자 메시지 오래된 순)
   * @example "latestAll"
   */
  sortType?: "latestAll" | "newInquiry" | "longestWait";
  /**
   * 페이지 오프셋 (기본값: 0)
   * @example 0
   */
  offset?: number;
  /**
   * 페이지 크기 (기본값: 20)
   * @example 20
   */
  limit?: number;
}

export type ChatRoomControllerPaginationData = ChatRoomControllerPaginationResponse;

export interface ChatRoomControllerPaginationCountParams {
  /** 필터: total(전체), unread(읽지않음), unanswered(답변안함), answered(답변함) */
  filter?: "total" | "unread" | "unanswered" | "answered";
  /**
   * 채널별 ID 필터 (JSON 문자열): 각 채팅 타입별로 ID 배열 전달. 복수 선택 시 OR 조건으로 작동
   * @example "{"line":["lineBotID1"],"instagram":["instagramLoginID1"],"patient":[]}"
   */
  channels?: string;
  /** 검색 키워드 타입: patientName(환자명), phoneNumber(전화번호), counselorName(담당자명), chartNumber(차트번호), customTag(고객태그), datePeriod(기간), content(메시지 본문) */
  keyword?: "patientName" | "phoneNumber" | "counselorName" | "chartNumber" | "customTag" | "datePeriod" | "content";
  /**
   * 검색할 값 (keyword와 함께 사용; datePeriod 일 때는 무시되고 startDate/endDate 를 사용)
   * @example "김민재"
   */
  keywordValue?: string;
  /**
   * 고객 태그 그룹 ID
   * @example "customTagGroupID1"
   */
  customTagGroupID?: string;
  /**
   * 기간 검색 시작 (ISO 8601, keyword=datePeriod 일 때만 사용)
   * @example "2026-01-01T00:00:00Z"
   */
  startDate?: string;
  /**
   * 기간 검색 종료 (ISO 8601, keyword=datePeriod 일 때만 사용)
   * @example "2026-05-13T23:59:59Z"
   */
  endDate?: string;
  /**
   * 정렬 타입: latestAll(기본), newInquiry, longestWait
   * @example "latestAll"
   */
  sortType?: "latestAll" | "newInquiry" | "longestWait";
}

export type ChatRoomControllerPaginationCountData = ChatRoomControllerPaginationCountResponse;

export interface ChatRoomControllerUnreadCountParams {
  /** 병원 ID */
  hospitalID: string;
  /** 직원(상담자) 유저 ID */
  userID: string;
  /**
   * 관리자 채팅방 여부 (boolean string: true/false)
   * @example "false"
   */
  isDoctor?: string;
  /**
   * 채팅방 활성화 여부 (boolean string: true/false)
   * @example "true"
   */
  isActive?: string;
  /**
   * 상담 진행 여부 (boolean string: true/false)
   * @example "true"
   */
  isCounselInProgress?: string;
  /** 검색 키워드 (title / parentTitle 부분 일치) */
  keyword?: string;
}

export type ChatRoomControllerUnreadCountData = ChatRoomControllerUnreadCountResponse;

export type ChatRoomControllerToggleTranslateData = ChatRoomControllerToggleTranslateResponse;

export type ChatRoomControllerToggleTranslateCheckData = ChatRoomControllerToggleTranslateCheckResponse;

export type ChatRoomControllerUpdateTranslateLanguageData = ChatRoomControllerUpdateTranslateLanguageResponse;

export type ChatRoomControllerFindTranslateLanguageData = ChatRoomControllerFindTranslateLanguageListResponse;

export type ChatRoomControllerAddCounselorsData = ChatRoomControllerAddCounselorsResponse;

export interface ChatRoomControllerFindOneParams {
  /** 채팅방 ID */
  chatRoomID: string;
}

export type ChatRoomControllerFindOneData = ChatRoomControllerFindOneResponse;

export type ChatRoomControllerMarkAsReadData = ChatRoomControllerMarkAsReadResponse;

export interface MsoChatRoomControllerMsoUnreadCountParams {
  /** 관리자 채팅방 여부 */
  isDoctor?: boolean;
  /** 채팅방 활성화 여부 */
  isActive?: boolean;
  /** 상담 진행 여부 */
  isCounselInProgress?: boolean;
}

export type MsoChatRoomControllerMsoUnreadCountData = MSOChatRoomControllerMsoUnreadCountResponse;

export interface ChatRoomElPaginationHandlerParams {
  hospitalID: string;
  /** 카테고리: inProgress(진행중), completed(상담완료), important(중요) */
  category: "inProgress" | "completed" | "important";
  /** 필터: total(전체), unread(읽지않음), unanswered(답변안함), answered(답변함) */
  filter?: "total" | "unread" | "unanswered" | "answered";
  /**
   * 채널별 ID 필터 (JSON 문자열): 각 채팅 타입별로 ID 배열 전달. 복수 선택 시 OR 조건으로 작동
   * @example "
   *             {
   *                 "line":["lineBotID1","lineBotID2"],
   *                 "talktalk":["talktalkBusinessCenterID1","talktalkBusinessCenterID2"],
   *                 "instagram":["instagramLoginID1","instagramLoginID2"],
   *                 "whatsapp":["channelID1","channelID2"],
   *                 "ikakao":["pf_id1","pf_id2"],
   *                 "wechat":["channelID1","channelID2"],
   *                 "patient":[]
   *             }
   *             "
   */
  channels?: string;
  /** 검색 키워드 타입: patientName(환자명), phoneNumber(전화번호), counselorName(담당자명), chartNumber(차트번호), customTag(고객태그) */
  keyword?: "patientName" | "phoneNumber" | "counselorName" | "chartNumber" | "customTag";
  /**
   * 검색할 값 (keyword와 함께 사용)
   * @example "김민재"
   */
  keywordValue?: string;
  /**
   * 고객 태그 그룹 ID
   * @example "customTagGroupID1"
   */
  customTagGroupID?: string;
  /**
   * 페이지 오프셋 (기본값: 0)
   * @example 0
   */
  offset?: number;
  /**
   * 페이지 크기 (기본값: 20)
   * @example 20
   */
  limit?: number;
}

export type ChatRoomElPaginationHandlerData = ChatRoomELPaginationHandlerResponse;

export interface ChatRoomElPaginationCountHandlerParams {
  hospitalID: string;
  /** 필터: total(전체), unread(읽지않음), unanswered(답변안함), answered(답변함) */
  filter?: "total" | "unread" | "unanswered" | "answered";
  /**
   * 채널별 ID 필터 (JSON 문자열): 각 채팅 타입별로 ID 배열 전달. 복수 선택 시 OR 조건으로 작동
   * @example "
   *             {
   *                 "line":["lineBotID1","lineBotID2"],
   *                 "talktalk":["talktalkBusinessCenterID1","talktalkBusinessCenterID2"],
   *                 "instagram":["instagramLoginID1","instagramLoginID2"],
   *                 "whatsapp":["channelID1","channelID2"],
   *                 "ikakao":["pf_id1","pf_id2"],
   *                 "wechat":["channelID1","channelID2"],
   *                 "patient":[]
   *             }
   *             "
   */
  channels?: string;
  /** 검색 키워드 타입: patientName(환자명), phoneNumber(전화번호), counselorName(담당자명), chartNumber(차트번호), customTag(고객태그) */
  keyword?: "patientName" | "phoneNumber" | "counselorName" | "chartNumber" | "customTag";
  /**
   * 검색할 값 (keyword와 함께 사용)
   * @example "김민재"
   */
  keywordValue?: string;
  /**
   * 고객 태그 그룹 ID
   * @example "customTagGroupID1"
   */
  customTagGroupID?: string;
}

export type ChatRoomElPaginationCountHandlerData = ChatRoomELPaginationCountHandlerResponse;

export interface ChatRoomHmPaginationHandlerParams {
  hospitalID: string;
  /** 카테고리: inProgress(진행중), completed(상담완료), important(중요) */
  category: "inProgress" | "completed" | "important";
  /** 필터: total(전체), unread(읽지않음), unanswered(답변안함), answered(답변함) */
  filter?: "total" | "unread" | "unanswered" | "answered";
  /**
   * 채널별 ID 필터 (JSON 문자열): 각 채팅 타입별로 ID 배열 전달. 복수 선택 시 OR 조건으로 작동
   * @example "
   *             {
   *                 "line":["lineBotID1","lineBotID2"],
   *                 "talktalk":["talktalkBusinessCenterID1","talktalkBusinessCenterID2"],
   *                 "instagram":["instagramLoginID1","instagramLoginID2"],
   *                 "whatsapp":["channelID1","channelID2"],
   *                 "ikakao":["pf_id1","pf_id2"],
   *                 "wechat":["channelID1","channelID2"],
   *                 "patient":[]
   *             }
   *             "
   */
  channels?: string;
  /** 검색 키워드 타입: patientName(환자명), phoneNumber(전화번호), counselorName(담당자명), chartNumber(차트번호), customTag(고객태그) */
  keyword?: "patientName" | "phoneNumber" | "counselorName" | "chartNumber" | "customTag";
  /**
   * 검색할 값 (keyword와 함께 사용)
   * @example "김민재"
   */
  keywordValue?: string;
  /**
   * 고객 태그 그룹 ID
   * @example "customTagGroupID1"
   */
  customTagGroupID?: string;
  /**
   * 페이지 오프셋 (기본값: 0)
   * @example 0
   */
  offset?: number;
  /**
   * 페이지 크기 (기본값: 20)
   * @example 20
   */
  limit?: number;
}

export type ChatRoomHmPaginationHandlerData = ChatRoomHMPaginationHandlerResponse;

export interface ChatRoomHmPaginationCountHandlerParams {
  hospitalID: string;
  /** 필터: total(전체), unread(읽지않음), unanswered(답변안함), answered(답변함) */
  filter?: "total" | "unread" | "unanswered" | "answered";
  /**
   * 채널별 ID 필터 (JSON 문자열): 각 채팅 타입별로 ID 배열 전달. 복수 선택 시 OR 조건으로 작동
   * @example "
   *             {
   *                 "line":["lineBotID1","lineBotID2"],
   *                 "talktalk":["talktalkBusinessCenterID1","talktalkBusinessCenterID2"],
   *                 "instagram":["instagramLoginID1","instagramLoginID2"],
   *                 "whatsapp":["channelID1","channelID2"],
   *                 "ikakao":["pf_id1","pf_id2"],
   *                 "wechat":["channelID1","channelID2"],
   *                 "patient":[]
   *             }
   *             "
   */
  channels?: string;
  /** 검색 키워드 타입: patientName(환자명), phoneNumber(전화번호), counselorName(담당자명), chartNumber(차트번호), customTag(고객태그) */
  keyword?: "patientName" | "phoneNumber" | "counselorName" | "chartNumber" | "customTag";
  /**
   * 검색할 값 (keyword와 함께 사용)
   * @example "김민재"
   */
  keywordValue?: string;
  /**
   * 고객 태그 그룹 ID
   * @example "customTagGroupID1"
   */
  customTagGroupID?: string;
}

export type ChatRoomHmPaginationCountHandlerData = ChatRoomHMPaginationCountHandlerResponse;

export type ChatRoomMUpdateHandlerData = ChatRoomMUpdateHandlerResponse;

export interface ChatRoomMFindOneHandlerParams {
  chatRoomID?: string;
}

export type ChatRoomMFindOneHandlerData = ChatRoomMFindOneHandlerResponse;

export type ChatRoomMUpdateReadHandlerData = ChatRoomMUpdateReadHandlerResponse;

export interface ChatRoomElFindServiceInformationHandlerParams {
  chatRoomID: string;
}

export type ChatRoomElFindServiceInformationHandlerData = ChatRoomELFindServiceInformationHandlerResponse;

export interface ChatRoomHmFindServiceInformationHandlerParams {
  chatRoomID: string;
}

export type ChatRoomHmFindServiceInformationHandlerData = ChatRoomHMFindServiceInformationHandlerResponse;

export type ChatRoomElStarChatroomHandlerData = ChatRoomELStarChatroomHandlerResponse;

export type ChatRoomHmStarChatroomHandlerData = ChatRoomHMStarChatroomHandlerResponse;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * No description
     *
     * @tags V3-ChatRoom
     * @name ApiChatroomElFind
     * @summary 채팅방 정보 조회 및 검색
     * @request GET:/v3/api/chatroom/el/find
     * @deprecated
     * @secure
     * @response `200` `ApiChatroomElFindData` \[\{ChatRoom\}\] 채팅방 객체 배열
     */
    apiChatroomElFind: (query: ApiChatroomElFindParams, params: RequestParams = {}) =>
      this.request<ApiChatroomElFindData, any>({
        path: `/v3/api/chatroom/el/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ChatRoom
     * @name ApiChatroomElFindOne
     * @summary 채팅방 정보 조회 및 검색
     * @request GET:/v3/api/chatroom/el/find/one
     * @secure
     * @response `200` `ApiChatroomElFindOneData` \{ChatRoom\} 채팅방 객체
     */
    apiChatroomElFindOne: (query: ApiChatroomElFindOneParams, params: RequestParams = {}) =>
      this.request<ApiChatroomElFindOneData, any>({
        path: `/v3/api/chatroom/el/find/one`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ChatRoom
     * @name ApiChatroomElCount
     * @summary 채팅방 수 조회
     * @request GET:/v3/api/chatroom/el/count
     * @deprecated
     * @secure
     * @response `200` `ApiChatroomElCountData` ChatRoom 채팅방 수
     */
    apiChatroomElCount: (query: ApiChatroomElCountParams, params: RequestParams = {}) =>
      this.request<ApiChatroomElCountData, any>({
        path: `/v3/api/chatroom/el/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ChatRoom
     * @name ApiChatroomElUnreadcount
     * @summary 읽지않은 채팅 정보 조회
     * @request GET:/v3/api/chatroom/el/unreadcount
     * @secure
     * @response `200` `ApiChatroomElUnreadcountData` 안 읽은 채팅 수
     */
    apiChatroomElUnreadcount: (query: ApiChatroomElUnreadcountParams, params: RequestParams = {}) =>
      this.request<ApiChatroomElUnreadcountData, any>({
        path: `/v3/api/chatroom/el/unreadcount`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ChatRoom
     * @name ApiChatroomElUpdate
     * @summary 채팅방 수정
     * @request POST:/v3/api/chatroom/el/update
     * @secure
     * @response `200` `ApiChatroomElUpdateData` \{ChatRoom\} 수정된 채팅방 객체
     */
    apiChatroomElUpdate: (
      data: {
        /** 수정하고자 하는 채팅방의 ID */
        _id: string;
        /** 번역할 언어. languageCodeISOAlpha2 로 발송 */
        language?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatroomElUpdateData, any>({
        path: `/v3/api/chatroom/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ChatRoom
     * @name ApiChatroomElUpdateRead
     * @summary 채팅방 수정 - 읽음 처리 (POST /v3/api/chatroom/update/read 로 대체됨)
     * @request POST:/v3/api/chatroom/el/update/read
     * @deprecated
     * @secure
     * @response `200` `ApiChatroomElUpdateReadData` \{ChatRoom\} 수정된 채팅방 객체
     */
    apiChatroomElUpdateRead: (
      data: {
        /** 채팅방 ID */
        chatRoomID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatroomElUpdateReadData, any>({
        path: `/v3/api/chatroom/el/update/read`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ChatRoom
     * @name ApiChatroomElUpdateCounselStatus
     * @summary 채팅방 수정 - 상담 종료 업데이트
     * @request POST:/v3/api/chatroom/el/update/counsel/status
     * @secure
     * @response `200` `ApiChatroomElUpdateCounselStatusData` \{ChatRoom\} 수정된 채팅방 객체
     */
    apiChatroomElUpdateCounselStatus: (
      data: {
        /** 수정하고자 하는 채팅방의 ID */
        chatRoomID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatroomElUpdateCounselStatusData, any>({
        path: `/v3/api/chatroom/el/update/counsel/status`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ChatRoom
     * @name ApiChatroomElUpdateCounselCounselor
     * @summary (deprecated) 채팅방 수정 - 담당자 변경
     * @request POST:/v3/api/chatroom/el/update/counsel/counselor
     * @deprecated
     * @secure
     * @response `200` `ApiChatroomElUpdateCounselCounselorData` \{ChatRoom\} 수정된 채팅방 객체
     */
    apiChatroomElUpdateCounselCounselor: (
      data: {
        /** 수정하고자 하는 채팅방의 ID */
        chatRoomID?: string;
        /** 수정하고자 하는 채팅방의 담당자 userID */
        counselorID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatroomElUpdateCounselCounselorData, any>({
        path: `/v3/api/chatroom/el/update/counsel/counselor`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ChatRoom
     * @name ApiChatroomElUserAdd
     * @summary 채팅방 유저 추가
     * @request POST:/v3/api/chatroom/el/user/add
     * @secure
     * @response `200` `ApiChatroomElUserAddData` \{ChatRoom\} 수정된 채팅방 객체
     */
    apiChatroomElUserAdd: (
      data: {
        /**
         * 수정하고자 하는 채팅방 ID
         * @example "6114ce8752232b5b32afada7"
         */
        chatRoomID?: string;
        /**
         * 추가하고자 하는 유저의 아이디 배열
         * @example ["613d950d25276223a9b344d4","613da51ac9d4ea2ae808ccd2"]
         */
        userIDs?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatroomElUserAddData, any>({
        path: `/v3/api/chatroom/el/user/add`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ChatRoom
     * @name ApiChatroomElUserRemove
     * @summary 채팅방 유저 제외
     * @request POST:/v3/api/chatroom/el/user/remove
     * @secure
     * @response `200` `ApiChatroomElUserRemoveData` \{ChatRoom\} 수정된 채팅방 객체
     */
    apiChatroomElUserRemove: (
      data: {
        /** 수정하고자 하는 채팅방 ID */
        chatRoomID?: string;
        /** 제거하고자 하는 유저의 아이디 배열 */
        userIDs?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatroomElUserRemoveData, any>({
        path: `/v3/api/chatroom/el/user/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ChatRoom
     * @name ApiChatroomElUserRemoveAll
     * @summary 참여한 고객 채팅방에서 모두 나가기. 병원 직원만 사용 가능한 API
     * @request POST:/v3/api/chatroom/el/user/remove/all
     * @deprecated
     * @secure
     * @response `200` `ApiChatroomElUserRemoveAllData` \[\{ChatRoom\}\] 나가기 처리된 채팅방 목록
     */
    apiChatroomElUserRemoveAll: (
      data: {
        /** 채팅방 모두 나가기를 수행할 병원 */
        hospitalID?: string;
        /** 제거하고자 하는 유저의 아이디 배열 */
        userIDs?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatroomElUserRemoveAllData, any>({
        path: `/v3/api/chatroom/el/user/remove/all`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ChatRoom
     * @name ApiChatroomElCounselorAdd
     * @summary 채팅방 담당자 추가
     * @request POST:/v3/api/chatroom/el/counselor/add
     * @deprecated
     * @secure
     * @response `200` `ApiChatroomElCounselorAddData` \{ChatRoom\} 수정된 채팅방 객체
     */
    apiChatroomElCounselorAdd: (
      data: {
        /**
         * 수정하고자 하는 채팅방 ID
         * @example "6114ce8752232b5b32afada7"
         */
        chatRoomID?: string;
        /**
         * 추가하고자 하는 담당자의 userID 배열
         * @example ["613d950d25276223a9b344d4","613da51ac9d4ea2ae808ccd2"]
         */
        counselors?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatroomElCounselorAddData, any>({
        path: `/v3/api/chatroom/el/counselor/add`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ChatRoom
     * @name ApiChatroomElDetectLanguage
     * @summary 채팅방의 언어 추정. 환자의 최근 5건 채팅 조회 후 추정. 해당하는 언어 없을 시 'en' 값에 해당하는 것으로 리턴
     * @request POST:/v3/api/chatroom/el/detect/language
     * @deprecated
     * @secure
     * @response `200` `ApiChatroomElDetectLanguageData` \{Language\} 언어 객체
     */
    apiChatroomElDetectLanguage: (
      data: {
        /** (required) 전송할 채팅방 ObjectId */
        chatRoomID: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatroomElDetectLanguageData, any>({
        path: `/v3/api/chatroom/el/detect/language`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ChatRoom
     * @name ApiChatroomElUpdateTranslateToggle
     * @summary 채팅방 번역 토글 수정. 토글 켜기 시, 환자 채팅 최근 10건 번역 시도
     * @request POST:/v3/api/chatroom/el/update/translate/toggle
     * @deprecated
     * @secure
     * @response `200` `ApiChatroomElUpdateTranslateToggleData` \{ChatRoom\} 업데이트 된 ChatRoom 객체
     */
    apiChatroomElUpdateTranslateToggle: (
      data: {
        /** (required) 전송할 채팅방 ObjectId */
        chatRoomID: string;
        /** (required) 번역 사용 여부 */
        usingTranslation: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatroomElUpdateTranslateToggleData, any>({
        path: `/v3/api/chatroom/el/update/translate/toggle`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ChatRoom
     * @name ApiChatroomHmFind
     * @summary 병원 상담 모바일 앱 - 채팅방 정보 조회 및 검색
     * @request GET:/v3/api/chatroom/hm/find
     * @deprecated
     * @secure
     * @response `200` `ApiChatroomHmFindData` \[\{ChatRoom\}\] 채팅방 객체 배열
     */
    apiChatroomHmFind: (query: ApiChatroomHmFindParams, params: RequestParams = {}) =>
      this.request<ApiChatroomHmFindData, any>({
        path: `/v3/api/chatroom/hm/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ChatRoom
     * @name ApiChatroomHmFindOne
     * @summary 채팅방 정보 조회 및 검색
     * @request GET:/v3/api/chatroom/hm/find/one
     * @secure
     * @response `200` `ApiChatroomHmFindOneData` \{ChatRoom\} 채팅방 객체
     */
    apiChatroomHmFindOne: (query: ApiChatroomHmFindOneParams, params: RequestParams = {}) =>
      this.request<ApiChatroomHmFindOneData, any>({
        path: `/v3/api/chatroom/hm/find/one`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ChatRoom
     * @name ApiChatroomHmCount
     * @summary 병원 상담 모바일 앱 - 채팅방 수 조회
     * @request GET:/v3/api/chatroom/hm/count
     * @secure
     * @response `200` `ApiChatroomHmCountData` ChatRoom 채팅방 수
     */
    apiChatroomHmCount: (query: ApiChatroomHmCountParams, params: RequestParams = {}) =>
      this.request<ApiChatroomHmCountData, any>({
        path: `/v3/api/chatroom/hm/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ChatRoom
     * @name ApiChatroomHmUnreadcount
     * @summary 병원 상담 모바일 앱 - 내가 읽지 않은 채팅 전수 조회
     * @request GET:/v3/api/chatroom/hm/unreadcount
     * @secure
     * @response `200` `ApiChatroomHmUnreadcountData` 안 읽은 채팅 수
     */
    apiChatroomHmUnreadcount: (query: ApiChatroomHmUnreadcountParams, params: RequestParams = {}) =>
      this.request<ApiChatroomHmUnreadcountData, any>({
        path: `/v3/api/chatroom/hm/unreadcount`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ChatRoom
     * @name ApiChatroomHmUpdate
     * @summary 병원 상담 모바일 앱 - 채팅방 수정
     * @request POST:/v3/api/chatroom/hm/update
     * @secure
     * @response `200` `ApiChatroomHmUpdateData` \{ChatRoom\} 수정된 채팅방 객체
     */
    apiChatroomHmUpdate: (
      data: {
        /** 수정하고자 하는 채팅방의 ID */
        _id: string;
        /** 번역할 언어. languageCodeISOAlpha2 로 발송 */
        language?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatroomHmUpdateData, any>({
        path: `/v3/api/chatroom/hm/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ChatRoom
     * @name ApiChatroomHmUpdateRead
     * @summary 병원 상담 모바일 앱 - 채팅방 읽음 처리
     * @request POST:/v3/api/chatroom/hm/update/read
     * @secure
     * @response `200` `ApiChatroomHmUpdateReadData` \{ChatRoom\} 수정된 채팅방 객체
     */
    apiChatroomHmUpdateRead: (
      data: {
        /** 채팅방 ID */
        chatRoomID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatroomHmUpdateReadData, any>({
        path: `/v3/api/chatroom/hm/update/read`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ChatRoom
     * @name ApiChatroomHmUpdateCounselStatus
     * @summary 병원 상담 모바일 앱 - 채팅방 상담 종료 업데이트
     * @request POST:/v3/api/chatroom/hm/update/counsel/status
     * @secure
     * @response `200` `ApiChatroomHmUpdateCounselStatusData` \{ChatRoom\} 수정된 채팅방 객체
     */
    apiChatroomHmUpdateCounselStatus: (
      data: {
        /** 수정하고자 하는 채팅방의 ID */
        chatRoomID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatroomHmUpdateCounselStatusData, any>({
        path: `/v3/api/chatroom/hm/update/counsel/status`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ChatRoom
     * @name ApiChatroomHmUserRemove
     * @summary 병원 상담 모바일 앱 - 채팅방 유저 제외
     * @request POST:/v3/api/chatroom/hm/user/remove
     * @secure
     * @response `200` `ApiChatroomHmUserRemoveData` \{ChatRoom\} 수정된 채팅방 객체
     */
    apiChatroomHmUserRemove: (
      data: {
        /** 수정하고자 하는 채팅방 ID */
        chatRoomID?: string;
        /** 제거하고자 하는 유저의 아이디 배열 */
        userIDs?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatroomHmUserRemoveData, any>({
        path: `/v3/api/chatroom/hm/user/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ChatRoom
     * @name ApiChatroomHmCounselorAdd
     * @summary 병원 상담 모바일 앱 - 채팅방 담당자 추가
     * @request POST:/v3/api/chatroom/hm/counselor/add
     * @secure
     * @response `200` `ApiChatroomHmCounselorAddData` \{ChatRoom\} 수정된 채팅방 객체
     */
    apiChatroomHmCounselorAdd: (
      data: {
        /**
         * 수정하고자 하는 채팅방 ID
         * @example "6114ce8752232b5b32afada7"
         */
        chatRoomID?: string;
        /**
         * 추가하고자 하는 담당자의 userID 배열
         * @example ["613d950d25276223a9b344d4","613da51ac9d4ea2ae808ccd2"]
         */
        counselors?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatroomHmCounselorAddData, any>({
        path: `/v3/api/chatroom/hm/counselor/add`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ChatRoom
     * @name ApiChatroomHmUpdateTranslateToggle
     * @summary 병원 상담 모바일 앱 - 채팅방 번역 토글 수정. 토글 켜기 시, 환자 채팅 최근 10건 번역 시도
     * @request POST:/v3/api/chatroom/hm/update/translate/toggle
     * @deprecated
     * @secure
     * @response `200` `ApiChatroomHmUpdateTranslateToggleData` \{ChatRoom\} 업데이트 된 ChatRoom 객체
     */
    apiChatroomHmUpdateTranslateToggle: (
      data: {
        /** (required) 전송할 채팅방 ObjectId */
        chatRoomID: string;
        /** (required) 번역 사용 여부 */
        usingTranslation: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiChatroomHmUpdateTranslateToggleData, any>({
        path: `/v3/api/chatroom/hm/update/translate/toggle`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ChatRoom
     * @name ChatRoomControllerPagination
     * @summary 채팅방 페이지네이션
     * @request GET:/v3/api/chatroom/pagination
     * @secure
     * @response `200` `ChatRoomControllerPaginationData` success
     */
    chatRoomControllerPagination: (query: ChatRoomControllerPaginationParams, params: RequestParams = {}) =>
      this.request<ChatRoomControllerPaginationData, any>({
        path: `/v3/api/chatroom/pagination`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ChatRoom
     * @name ChatRoomControllerPaginationCount
     * @summary 채팅방 페이지네이션 카운트
     * @request GET:/v3/api/chatroom/pagination/count
     * @secure
     * @response `200` `ChatRoomControllerPaginationCountData` success
     */
    chatRoomControllerPaginationCount: (query: ChatRoomControllerPaginationCountParams, params: RequestParams = {}) =>
      this.request<ChatRoomControllerPaginationCountData, any>({
        path: `/v3/api/chatroom/pagination/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ChatRoom
     * @name ChatRoomControllerUnreadCount
     * @summary 읽지 않은 채팅 수 조회 (통합: v2/el + v3/el + v3/hm)
     * @request GET:/v3/api/chatroom/unreadcount
     * @secure
     * @response `200` `ChatRoomControllerUnreadCountData` success
     */
    chatRoomControllerUnreadCount: (query: ChatRoomControllerUnreadCountParams, params: RequestParams = {}) =>
      this.request<ChatRoomControllerUnreadCountData, any>({
        path: `/v3/api/chatroom/unreadcount`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ChatRoom
     * @name ChatRoomControllerToggleTranslate
     * @summary 채팅방 번역 토글 수정
     * @request POST:/v3/api/chatroom/translate/toggle
     * @secure
     * @response `200` `ChatRoomControllerToggleTranslateData` success
     */
    chatRoomControllerToggleTranslate: (
      data: ChatRoomControllerToggleTranslateBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<ChatRoomControllerToggleTranslateData, any>({
        path: `/v3/api/chatroom/translate/toggle`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ChatRoom
     * @name ChatRoomControllerToggleTranslateCheck
     * @summary 채팅방 번역 검수 토글 수정
     * @request POST:/v3/api/chatroom/translate/check/toggle
     * @secure
     * @response `200` `ChatRoomControllerToggleTranslateCheckData` success
     */
    chatRoomControllerToggleTranslateCheck: (
      data: ChatRoomControllerToggleTranslateCheckBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<ChatRoomControllerToggleTranslateCheckData, any>({
        path: `/v3/api/chatroom/translate/check/toggle`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ChatRoom
     * @name ChatRoomControllerUpdateTranslateLanguage
     * @summary 채팅방 번역 언어 수정
     * @request POST:/v3/api/chatroom/translate/language
     * @secure
     * @response `200` `ChatRoomControllerUpdateTranslateLanguageData` success
     */
    chatRoomControllerUpdateTranslateLanguage: (
      data: ChatRoomControllerUpdateTranslateLanguageBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<ChatRoomControllerUpdateTranslateLanguageData, any>({
        path: `/v3/api/chatroom/translate/language`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ChatRoom
     * @name ChatRoomControllerFindTranslateLanguage
     * @summary 채팅방 번역 가능 언어 리스트 조회
     * @request GET:/v3/api/chatroom/translate/language
     * @secure
     * @response `200` `ChatRoomControllerFindTranslateLanguageData` success
     */
    chatRoomControllerFindTranslateLanguage: (params: RequestParams = {}) =>
      this.request<ChatRoomControllerFindTranslateLanguageData, any>({
        path: `/v3/api/chatroom/translate/language`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ChatRoom
     * @name ChatRoomControllerAddCounselors
     * @summary 채팅방 담당자 추가
     * @request POST:/v3/api/chatroom/counselor
     * @secure
     * @response `200` `ChatRoomControllerAddCounselorsData` success
     */
    chatRoomControllerAddCounselors: (data: ChatRoomControllerAddCounselorsBodyRequest, params: RequestParams = {}) =>
      this.request<ChatRoomControllerAddCounselorsData, any>({
        path: `/v3/api/chatroom/counselor`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-ChatRoom
     * @name ChatRoomControllerFindOne
     * @summary 채팅방 정보 조회
     * @request GET:/v3/api/chatroom/find/one
     * @secure
     * @response `200` `ChatRoomControllerFindOneData` success
     */
    chatRoomControllerFindOne: (query: ChatRoomControllerFindOneParams, params: RequestParams = {}) =>
      this.request<ChatRoomControllerFindOneData, any>({
        path: `/v3/api/chatroom/find/one`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 직원이 채팅방을 열었을 때 미읽음을 정리한다. 읽기 전에 안 읽은 직원이 있었던 경우에만 다른 직원 화면 동기화용 데이터 푸시를 보낸다.
     *
     * @tags V3-ChatRoom
     * @name ChatRoomControllerMarkAsRead
     * @summary 채팅방 읽음 처리
     * @request POST:/v3/api/chatroom/update/read
     * @secure
     * @response `200` `ChatRoomControllerMarkAsReadData` success
     */
    chatRoomControllerMarkAsRead: (data: ChatRoomControllerMarkAsReadBodyRequest, params: RequestParams = {}) =>
      this.request<ChatRoomControllerMarkAsReadData, any>({
        path: `/v3/api/chatroom/update/read`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description MSO(userType 2501) 사용자가 소속된 모든 병원의 읽지 않은 채팅 수를 반환한다. 비-MSO 호출은 권한 에러를 반환한다.
     *
     * @tags V3-ChatRoom
     * @name MsoChatRoomControllerMsoUnreadCount
     * @summary MSO 병원별 읽지 않은 채팅 수 조회
     * @request GET:/v3/api/chatroom/mso/unreadcount
     * @secure
     * @response `200` `MsoChatRoomControllerMsoUnreadCountData` success
     */
    msoChatRoomControllerMsoUnreadCount: (
      query: MsoChatRoomControllerMsoUnreadCountParams,
      params: RequestParams = {},
    ) =>
      this.request<MsoChatRoomControllerMsoUnreadCountData, any>({
        path: `/v3/api/chatroom/mso/unreadcount`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 채팅방 페이지네이션
     *
     * @tags V3-ChatRoom
     * @name ChatRoomElPaginationHandler
     * @summary 채팅방 페이지네이션: ts
     * @request GET:/v3/api/chatroom/el/pagination
     * @deprecated
     * @secure
     * @response `200` `ChatRoomElPaginationHandlerData` success
     */
    chatRoomElPaginationHandler: (query: ChatRoomElPaginationHandlerParams, params: RequestParams = {}) =>
      this.request<ChatRoomElPaginationHandlerData, any>({
        path: `/v3/api/chatroom/el/pagination`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 채팅방 페이지네이션 수 조회 (진행중/완료/중요) 모두 포함
     *
     * @tags V3-ChatRoom
     * @name ChatRoomElPaginationCountHandler
     * @summary 채팅방 페이지네이션 수 조회: ts
     * @request GET:/v3/api/chatroom/el/pagination/count
     * @deprecated
     * @secure
     * @response `200` `ChatRoomElPaginationCountHandlerData` success
     */
    chatRoomElPaginationCountHandler: (query: ChatRoomElPaginationCountHandlerParams, params: RequestParams = {}) =>
      this.request<ChatRoomElPaginationCountHandlerData, any>({
        path: `/v3/api/chatroom/el/pagination/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 채팅방 페이지네이션
     *
     * @tags V3-ChatRoom
     * @name ChatRoomHmPaginationHandler
     * @summary 채팅방 페이지네이션: ts
     * @request GET:/v3/api/chatroom/hm/pagination
     * @deprecated
     * @secure
     * @response `200` `ChatRoomHmPaginationHandlerData` success
     */
    chatRoomHmPaginationHandler: (query: ChatRoomHmPaginationHandlerParams, params: RequestParams = {}) =>
      this.request<ChatRoomHmPaginationHandlerData, any>({
        path: `/v3/api/chatroom/hm/pagination`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 채팅방 페이지네이션 수 조회 (진행중/완료/중요) 모두 포함
     *
     * @tags V3-ChatRoom
     * @name ChatRoomHmPaginationCountHandler
     * @summary 채팅방 페이지네이션 수 조회: ts
     * @request GET:/v3/api/chatroom/hm/pagination/count
     * @deprecated
     * @secure
     * @response `200` `ChatRoomHmPaginationCountHandlerData` success
     */
    chatRoomHmPaginationCountHandler: (query: ChatRoomHmPaginationCountHandlerParams, params: RequestParams = {}) =>
      this.request<ChatRoomHmPaginationCountHandlerData, any>({
        path: `/v3/api/chatroom/hm/pagination/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 채팅방 정보 업데이트
     *
     * @tags V3-ChatRoom
     * @name ChatRoomMUpdateHandler
     * @summary 채팅방 정보 업데이트: ts
     * @request PATCH:/v3/api/chatroom/m/update
     * @secure
     * @response `200` `ChatRoomMUpdateHandlerData` success
     */
    chatRoomMUpdateHandler: (data: ChatRoomMUpdateHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<ChatRoomMUpdateHandlerData, any>({
        path: `/v3/api/chatroom/m/update`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 채팅방 정보 조회
     *
     * @tags V3-ChatRoom
     * @name ChatRoomMFindOneHandler
     * @summary 채팅방 정보 조회: ts
     * @request GET:/v3/api/chatroom/m/find/one
     * @secure
     * @response `200` `ChatRoomMFindOneHandlerData` success
     */
    chatRoomMFindOneHandler: (query: ChatRoomMFindOneHandlerParams, params: RequestParams = {}) =>
      this.request<ChatRoomMFindOneHandlerData, any>({
        path: `/v3/api/chatroom/m/find/one`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 채팅방 수정 - 읽음 처리
     *
     * @tags V3-ChatRoom
     * @name ChatRoomMUpdateReadHandler
     * @summary 채팅방 수정 - 읽음 처리 : ts
     * @request PATCH:/v3/api/chatroom/m/update/read
     * @secure
     * @response `200` `ChatRoomMUpdateReadHandlerData` success
     */
    chatRoomMUpdateReadHandler: (data: ChatRoomMUpdateReadHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<ChatRoomMUpdateReadHandlerData, any>({
        path: `/v3/api/chatroom/m/update/read`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 채팅방에 연결된 서비스 정보 조회
     *
     * @tags V3-ChatRoom
     * @name ChatRoomElFindServiceInformationHandler
     * @summary 채팅방에 연결된 서비스 정보 조회: ts
     * @request GET:/v3/api/chatroom/el/hserviceinfo
     * @secure
     * @response `200` `ChatRoomElFindServiceInformationHandlerData` success
     */
    chatRoomElFindServiceInformationHandler: (
      query: ChatRoomElFindServiceInformationHandlerParams,
      params: RequestParams = {},
    ) =>
      this.request<ChatRoomElFindServiceInformationHandlerData, any>({
        path: `/v3/api/chatroom/el/hserviceinfo`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 상담 모바일 앱 - 채팅방에 연결된 서비스 정보 조회
     *
     * @tags V3-ChatRoom
     * @name ChatRoomHmFindServiceInformationHandler
     * @summary 병원 상담 모바일 앱 - 채팅방에 연결된 서비스 정보 조회: ts
     * @request GET:/v3/api/chatroom/hm/hserviceinfo
     * @secure
     * @response `200` `ChatRoomHmFindServiceInformationHandlerData` success
     */
    chatRoomHmFindServiceInformationHandler: (
      query: ChatRoomHmFindServiceInformationHandlerParams,
      params: RequestParams = {},
    ) =>
      this.request<ChatRoomHmFindServiceInformationHandlerData, any>({
        path: `/v3/api/chatroom/hm/hserviceinfo`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 채팅방 중요 표시 설정/해제
     *
     * @tags V3-ChatRoom
     * @name ChatRoomElStarChatroomHandler
     * @summary 채팅방 중요 표시 설정/해제: ts
     * @request POST:/v3/api/chatroom/el/star
     * @secure
     * @response `200` `ChatRoomElStarChatroomHandlerData` success
     */
    chatRoomElStarChatroomHandler: (
      data: {
        chatRoomID: string;
        hospitalID: string;
        isStarred: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ChatRoomElStarChatroomHandlerData, any>({
        path: `/v3/api/chatroom/el/star`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원 상담 모바일 앱 - 채팅방 중요 표시 설정/해제
     *
     * @tags V3-ChatRoom
     * @name ChatRoomHmStarChatroomHandler
     * @summary 병원 상담 모바일 앱 - 채팅방 중요 표시 설정/해제: ts
     * @request POST:/v3/api/chatroom/hm/star
     * @secure
     * @response `200` `ChatRoomHmStarChatroomHandlerData` success
     */
    chatRoomHmStarChatroomHandler: (
      data: {
        chatRoomID: string;
        hospitalID: string;
        isStarred: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ChatRoomHmStarChatroomHandlerData, any>({
        path: `/v3/api/chatroom/hm/star`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
